import React, { useState } from 'react'
import styled from 'styled-components'
import { HeroImageTitle } from 'components/new/hero'
import { Helmet } from 'react-helmet'
import Content from 'components/content-full-width'
import Layout from 'components/layout'
import ProductTable from 'components/new/product-table'
import { graphql } from 'gatsby'
import { useToggle } from 'hooks/use-toggle'
import Modal from 'components/modal/modal'
import QuoteForm from 'components/forms/quote'
import Section from 'components/section'
import BreadcrumbsScript from 'components/scripts/breadcrumbs'

const breadcrumbs = [
  {
    name: 'Home',
    schemaName: 'Hutson Inc',
    link: '/',
  },
  {
    name: 'Construction Equipment',
    link: '/construction/',
  },
  {
    name: 'Attachments',
    link: '/construction/attachments/',
  },
  {
    name: 'Planers',
    link: '/construction/attachments/planers/',
  },
]

const PlanersAttachmentsPage = ({ data, location }) => {
  const { allDeereConstructionAttachment, heroImage } = data
  const [modalOpen, toggleModal] = useToggle(false)
  const [selectedProduct, setSelectedProduct] = useState('')

  const handleProductOnClick = e => {
    const productName = e.target.getAttribute('data-name')
    setSelectedProduct(productName)
    toggleModal()
  }

  const productTables = allDeereConstructionAttachment.nodes.reduce((acc, node) => {
    const matchIndex = acc.findIndex(obj => obj.title === node.subcategory)
    if (matchIndex === -1) {
      acc.push({
        title: node.subcategory,
        items: [
          {
            name: node.name,
            tableData: node.tableData,
            onClick: handleProductOnClick,
          },
        ],
      })
    } else {
      acc[matchIndex].items.push({
        name: node.name,
        tableData: node.tableData,
        onClick: handleProductOnClick,
      })
    }
    return acc
  }, [])
  return (
    <Layout>
      <Helmet>
        <title>John Deere Planers | Hutson Inc</title>
      </Helmet>

      <BreadcrumbsScript breadcrumbs={breadcrumbs} />

      <Hero
        image={heroImage.childImageSharp.gatsbyImageData}
        title='Planers'
        breadcrumbs={breadcrumbs}
      />

      <Content>
        {productTables.map((table, key) => (
          <CategorySection key={table.title || key}>
            {table.title && <CategoryTitle>{table.title}</CategoryTitle>}
            <ProductTable items={table.items} />
          </CategorySection>
        ))}
      </Content>

      <Modal toggle={toggleModal} isOpen={modalOpen}>
        <QuoteForm
          toggleModal={toggleModal}
          productName={selectedProduct}
          productType='construction-attachment'
          submitButtonClass='submit-aftermarket-quote'
          pageURL={location.href}
          equipmentBrand='John Deere'
          equipmentCondition='new'
        />
      </Modal>
    </Layout>
  )
}

const Hero = styled(HeroImageTitle)`
  height: 300px;

  @media ${props => props.theme.mediaQuery.medium} {
    height: 400px;
  }

  @media ${props => props.theme.mediaQuery.largeUp} {
    height: 450px;
  }
`

const CategorySection = styled(Section)`
  :first-of-type {
    margin: 0;
  }
`

const CategoryTitle = styled.h2`
  margin: 0 0 24px;
`

export const pageQuery = graphql`
  query planersAttachmentsQuery($category: String! = "Planers") {
    heroImage: file(relativePath: { eq: "construction/attachments/cold-planer.jpg" }) {
      ...FullWidthImage
    }
    allDeereConstructionAttachment(filter: { categories: { in: [$category] } }) {
      nodes {
        id
        categories
        subcategory
        name
        tableData {
          property
          data
        }
      }
    }
  }
`

export default PlanersAttachmentsPage
